import React, { useState, useRef, useCallback, useEffect } from 'react';
import WavesurferPlayer from '@wavesurfer/react';
import { useAudioPlayer } from '../../contexts/AudioPlayerContext';
import { useFileLoader } from '../../hooks/useFileLoader';
// Импортируем стили, если они нужны
import './WaveformPlayer.css';

const WaveformPlayer = ({ 
  audioSrc, 
  name = 'Voice message', 
  onPlayStateChange,
  downloadEnabled = true,
  fileName,
  playerId
  }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  // Ссылка на экземпляр wavesurfer, чтобы управлять им извне
  const wavesurferRef = useRef(null);
  const intervalRef = useRef(null);
  const { fileUrl } = useFileLoader(audioSrc);
  
  

   const { registerPlayer, unregisterPlayer, playPlayer, pausePlayer, isActive, playNext } = useAudioPlayer();

   const isActivePlayer = isActive(playerId);
    // Регистрируем плеер в контексте
  useEffect(() => {
    if (!playerId) return;

    const controls = {
      play: () => {
        if (wavesurferRef.current) {
          wavesurferRef.current.play();
        }
      },
      pause: () => {
        if (wavesurferRef.current) {
          wavesurferRef.current.pause();
        }
      },
      stop: () => {
        if (wavesurferRef.current) {
          wavesurferRef.current.stop();
        }
      },
      isPlaying: () => {
        return wavesurferRef.current?.isPlaying() || false;
      }
    };

    registerPlayer(playerId, controls);

    return () => {
      unregisterPlayer(playerId);
    };
  }, [playerId, registerPlayer, unregisterPlayer]);

  // Обновление текущего времени
  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        if (wavesurferRef.current) {
          const time = wavesurferRef.current.getCurrentTime();
          setCurrentTime(time);
        }
      }, 100);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPlaying]);

   // Синхронизация с активным состоянием
  useEffect(() => {
    if (!isActivePlayer && isPlaying) {
      // Если плеер стал неактивным - останавливаем
      wavesurferRef.current?.pause();
      setIsPlaying(false);
      if (onPlayStateChange) onPlayStateChange(false);
    }
  }, [isActivePlayer, isPlaying, onPlayStateChange]);

  // Колбэки для событий wavesurfer
  const onReady = useCallback((ws) => {
    wavesurferRef.current = ws;    
    setDuration(ws.getDuration());
    // Можно установить громкость или другие настройки при готовности
     ws.setVolume(0.7);
  }, []);

  const onPlay = useCallback(() => {
    setIsPlaying(true);
    if (onPlayStateChange) onPlayStateChange(true);
     if (playerId) {
      playPlayer(playerId);
    }
  }, [onPlayStateChange, playerId, playPlayer]);

  const onPause = useCallback(() => {
    setIsPlaying(false);
    if (onPlayStateChange) onPlayStateChange(false);
     if (playerId) {
      pausePlayer(playerId);
    }
  }, [onPlayStateChange, playerId, pausePlayer]);

  const onFinish = useCallback(() => {
    setIsPlaying(false);
    
    if (onPlayStateChange) onPlayStateChange(false);

    // Можно перемотать в начало
     wavesurferRef.current?.seekTo(0);
     if (playerId) {
      pausePlayer(playerId);
      playNext(playerId);
    }
  }, [onPlayStateChange, playerId, pausePlayer, playNext]);

  // const onTimeUpdate = useCallback((currentTime) => {
  //   setCurrentTime(currentTime);
  // }, []);

  const togglePlay = useCallback(() => {
    if (!wavesurferRef.current) return;

    if (isPlaying) {
      wavesurferRef.current.pause();
    } else {
      // Если плеер не активен, контекст сам остановит другие
      wavesurferRef.current.play();
    }
  }, [isPlaying]);
  const handleDownload = useCallback(async () => {
    try {
      // Способ 1: Скачивание через fetch (если аудио доступно по URL)
      const response = await fetch(audioSrc);
      const blob = await response.blob();
      
      // Создаем ссылку для скачивания
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Имя файла
      const downloadName = fileName || name || 'voice-message';
      link.download = `${downloadName}`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Освобождаем память
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при скачивании:', error);
      
      
    }
  }, [audioSrc, fileName, name]);
 // Функция форматирования времени
  const formatTime = (time) => {
    if (!time || isNaN(time) || !isFinite(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };
   return (
    <div className="waveform-player">
      <button className="waveform-player__play-btn" onClick={togglePlay}>
        {isPlaying ? (
          <svg viewBox="0 0 24 24" width="24" height="24">
            <rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor" />
            <rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="24" height="24">
            <polygon points="5,3 19,12 5,21" fill="currentColor" />
          </svg>
        )}
      </button>

      <div className="waveform-player__info">
        {/* <div className="waveform-player__name">{name}</div> */}
        
        {/* Волновая форма */}
         
                <WavesurferPlayer
                ref={wavesurferRef}
                height={40}        
                
                waveColor="#8e8e93"
                progressColor="#33ff00"
                cursorColor="transparent"
                barWidth={1}
                barGap={2}
                barRadius={2}
                url={fileUrl}
                onReady={onReady}
                onPlay={onPlay}
                onPause={onPause}
                onFinish={onFinish}                
                />
                
                {/* Отображение времени */}
                <div className="waveform-player__time-overlay">
                <span className="waveform-player__time-current">
                    {formatTime(currentTime)}
                </span>
                <span className="waveform-player__time-total">
                    {formatTime(duration)}
                </span>
                </div>
            </div>
      
      
      {downloadEnabled && (
        <button 
          className="waveform-player__download-btn"
          onClick={handleDownload}
          aria-label="Скачать аудио"
          title="Скачать аудио"
        >
          <svg viewBox="0 0 24 24" width="20" height="20">
          <path 
            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" 
            fill="currentColor"
          />
        </svg>
        </button>
         )}
         </div>
    
  );
};

export default WaveformPlayer;